import { components } from 'react-select';
import { withClassName } from '../helpers';
export var GenericSelectControlSingleValue = withClassName(components.SingleValue, 'singleValue');